import { uniq } from 'lodash';
import { CAMERA, CHANGE_NAME, HAND_UP, MEETING_MODE, MESSAGE, MICROPHONE, POLL, RECORD, SHARING_FILE, SHARING_SCREEN, WHITEBOARD } from '../constants';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function useHandleDataSchedule() {
    const [operatorList, setOperatorList] = useState([]);
    const [userListId, setUserListId] = useState([]); 
    const [checkDurationMax, setCheckDurationMax] = useState(true);
    const [checkDurationMin, setCheckDurationMin] = useState(true);
    const [isPassword, setisPassword] = useState(false);
    const [isCreate, setIsCreate] = useState(true);
    const [count, setCount] = useState(0);
    const [openModalConfirmPassword, setOpenModalConfirmPassword] = useState(false);
    const [isPeriod, setIsPeriod] = useState(false);
    const dataPeriod = useSelector((state) => state.modelPeriod);
    const [isLobby, setIsLobby] = useState(false);
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState({
        roomId: null,
        roomName: '',
        parentRoomId: null,
        type: 'not_start',
        updatedAt: null,
        description: '',
        password: undefined,
        operatorList: [],
        participantList: [],
        setting: [],
        lobby: 0,
        camera: CAMERA.ON,
        micro: MICROPHONE.ON,
        message: MESSAGE.ON,
        sharingFile: SHARING_FILE.ON,
        pollPermission: POLL.HOST_AND_COHOST,
        meetingMode: MEETING_MODE.NORMAL,
        sharingScreenPermission: SHARING_SCREEN.ON,
        whiteboardPermission: WHITEBOARD.ON,
        handUpPermission: HAND_UP.ON,
        changeNamePermission: CHANGE_NAME.ON,
        recordPermission: RECORD.OFF,
        isTrash: 0,
        isModify: null,
        isPeriod: null,
        period: null,
        isChangePeriod: dataPeriod.isChangePeriod,
        noticeTimeEndRoom: 300
    })

    useEffect(() => {
      const listUser = [...data.operatorList, ...data.participantList];
      const userNameList = uniq(listUser.map(user => user.id))
      setUserListId(userNameList)
    }, [data.operatorList, data.participantList])
    
  return {
    data,
    setData,
    operatorList,
    setOperatorList,
    userListId,
    setUserListId,
    checkDurationMax,
    setCheckDurationMax,
    checkDurationMin,
    setCheckDurationMin,
    isPassword,
    setisPassword,
    isCreate,
    setIsCreate,
    count, 
    setCount,
    openModalConfirmPassword,
    setOpenModalConfirmPassword,
    isPeriod,
    setIsPeriod,
    isLobby,
    setIsLobby,
    loading, 
    setLoading
  }
}
